import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M18 1.657a7.637 7.637 0 0 1-2.121.557A3.577 3.577 0 0 0 17.503.258c-.713.405-1.504.7-2.345.858a3.767 3.767 0 0 0-2.696-1.117C10.422 0 8.77 1.582 8.77 3.534c0 .277.033.547.096.805-3.07-.147-5.79-1.554-7.612-3.692a3.401 3.401 0 0 0-.5 1.776c0 1.227.652 2.309 1.643 2.942a3.796 3.796 0 0 1-1.673-.442v.045c0 1.712 1.273 3.14 2.962 3.466a3.86 3.86 0 0 1-1.667.06c.47 1.404 1.834 2.426 3.45 2.455A7.624 7.624 0 0 1 .88 12.462c-.298 0-.592-.017-.881-.05A10.796 10.796 0 0 0 5.66 14c6.793 0 10.508-5.386 10.508-10.056 0-.153-.003-.305-.01-.457A7.338 7.338 0 0 0 18 1.657"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "twitter"}) } }